import { render } from "./base-page-header.vue?vue&type=template&id=32fc49b8&ts=true"
import script from "./base-page-header.vue?vue&type=script&lang=ts"
export * from "./base-page-header.vue?vue&type=script&lang=ts"

import "./base-page-header.vue?vue&type=style&index=0&id=32fc49b8&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__